const OPTIONS: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' }

const formatDate = (date: string) => new Date(date.replace(/-/g, '/')).toLocaleDateString('de-DE', OPTIONS)

export const formatDateRange = (begin?: string | null, end?: string | null): string => {
  if (!begin) {
    return ''
  }

  return end && end !== begin ? `${formatDate(begin)} – ${formatDate(end)}` : formatDate(begin)
}
